module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1BNbB2w/images/EveOfWarfare_cover.jpg?1684515199462",
      "alt": "This image is the cover for the book Eve of Warfare, Marked"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Eve of Warfare, Marked\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Lycans, vampires, and cherubs... oh my. All Evangeline Hollis wants is to stay out of trouble long enough to lose the Mark of Cain, which drafted her into hunting demons for God. A former agnostic, she’s still recovering from being the latest point of contention between the two men in her life--Cain and Abel. Now she’s working for a cherub who thinks putting her undercover as a housewife is the best way to ferret out a rogue vampire hiding in an idyllic Orange County, California residential community. Eve knows when she’s being used as a pawn in the celestial political game. Now, she just has to figure out who’s the greater threat: the vampire she’s hunting, the cherub yanking her chain, or the two brothers vying to play the role of her spouse--‘til death do them part. Which in her line of work, could happen any minute... (\"Eve of Warfare\" is a stand-alone novella, which falls after EVE OF CHAOS in the Marked series chronology.) Includes bonus content: the opening chapter of EVE OF DARKNESS")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sylvia Day, S.J. Day\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Sylvia Day\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0